<div class="cancel-signing">
  <div class="cancel-signing__header">
    <h3 data-testid="modal-header">Cancel signing verification</h3>
  </div>
  <div class="cancel-signing__body" data-testid="modal-text">
    <p>Are you sure you want to cancel the signing?</p>

    <form [formGroup]="optOutForm">
      @if (fixedCategoryTypeCode === 'CommentsOnly') {
        <app-text-area-input
          [dataTestId]="'cancel-signing-comments'"
          [errorMessage]="'Please enter comments regarding canceling this order'"
          [formControlRef]="comments"
          [isFullWidth]="true"
          [label]="'Comments'"
          [maxLength]="3000"
        ></app-text-area-input>
      }
    </form>
  </div>

  <app-button-container>
    <app-button
      type="secondary"
      (buttonClick)="handleBackButton()"
      [dataTestId]="'modal-close-cancel-signing'"
      >
      Back to Signing
    </app-button>
    <app-button
      type="warning"
      (buttonClick)="handleOptOut()"
      [dataTestId]="'modal-confirm-cancel-signing'"
      >
      Yes, Cancel the Signing
    </app-button>
  </app-button-container>
</div>
